<script>
import {defineComponent} from 'vue'
import {useWallet} from "solana-wallets-vue";
import collect from "collect.js";
// const solanaStakePool = require('@solana/spl-stake-pool');

// import TokenSelector from "./TokenSelector.vue";
import { getAssetsByOwner, getSolBalance } from "../utils/balances";
import {ElNotification} from "element-plus";
import {Connection, Transaction, PublicKey, VersionedTransaction, ComputeBudgetProgram} from "@solana/web3.js";
import {depositSol} from "@solana/spl-stake-pool";
import {depositSolIntoSanctum, depostSolIntoSanctum} from "../utils/sanctum";
const connection = new Connection("https://specific-lanny-fast-mainnet.helius-rpc.com/")


export default defineComponent({
    name: "StakeLst",
    // components: {TokenSelector},
    data() {
        return {
            input: '',
            output: '',
            inAmount: 0.1,
            outAmount: 0,
            wallet: useWallet(),
            tokens: [
                {
                    symbol: 'SOL',
                    icon: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
                    address: 'So11111111111111111111111111111111111111112',
                },
                {
                    symbol: 'compassSOL',
                    icon: "https://solanacompass.com/compass.png",
                    address: 'Comp4ssDzXcLeu2MnLuGNNFC4cmLPMng8qWHPvzAMU1h',
                }

            ],
            ratio: 1.01,
            pool: {},
            balances:{},
            quoteResponse: {},
        }
    },
    mounted() {

        this.input=this.tokens[0]
        this.output=this.tokens[1]
        axios.get('/stake-pools',{headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response) => {
            // let stakePools = collect(response.data[0]).keyBy('poolMint')
            let stakePools = response.data[0]
            console.log(stakePools)
            // this.pool =stakePools[this.tokens[1].address]
            this.pool =stakePools.filter(pool => pool.poolMint === this.tokens[1].address)[0]
            console.log(this.pool)
            this.ratio = 1/ (this.pool.totalLamports / this.pool.poolTokenSupply) *.999
            console.log(this.pool, this.ratio)
        });
        if(this.wallet.connected) this.getBalances()
        setTimeout(() => {
            this.getBalances()
            this.getSolQuote()
        }, 7000)
    },
    methods: {
        swap() {
           if(this.output === this.tokens[1]) this.stake()
           else this.unstake()
        },
        async stake() {
            console.log('stake', this.inAmount)
            const lamports = this.inAmount * 1e9
            const wallet = this.wallet




            let depositTx = await depositSolIntoSanctum(
                connection,
                new PublicKey('AwDeTcW6BovNYR34Df1TPm4bFwswa4CJY4YPye2LXtPS'),
                wallet.publicKey,
                lamports,
                undefined,
                undefined,
                undefined
            );
            let transaction = new Transaction();

            // first set priority fee
            const PRIORITY_RATE = 100; // MICRO_LAMPORTS
            const PRIORITY_FEE_IX = ComputeBudgetProgram.setComputeUnitPrice({microLamports: PRIORITY_RATE});
            transaction.add(PRIORITY_FEE_IX);
            transaction.add(...depositTx.instructions);
            console.log(depositTx, transaction)
            // console.log(transaction.signatures[0].publicKey.toString())
            // now, because this is Sanctum not SPL we need to mess with the program ID
            // transaction.instructions[2].programId = new PublicKey('SP12tWFxD9oJsVWNavTTBZvMbA6gkAmxtVgxdqvyvhY')

            const hash = await connection.getLatestBlockhash();
            transaction.recentBlockhash = hash.blockhash;
            transaction.feePayer = wallet.publicKey;
            // transaction  = await wallet.signTransaction(transaction)
            let signers = depositTx.signers;
            // if (signers.length > 0) {
            console.log(signers);
            transaction.sign(...signers);
            // }
            console.log(wallet, transaction)
            console.log(transaction.signatures[0].publicKey.toString())
            console.log(transaction.signatures[1].publicKey.toString())
            console.log(signers[0].publicKey.toString())

            let [ txid, success ] = await this.sendTx(transaction)
            if(success) {
                this.clicky('/stake/'+this.output.symbol+'/' + this.inAmount + '/' + txid)
                axios.post('/log/stake', {
                    txid: txid,
                    staker: this.wallet.publicKey,
                    amount: this.inAmount,
                    wallet: this.wallet.wallet.adapter.name,
                    stake_to: this.output.symbol
                })
            }

        },
        async getSolQuote() {
            if (this.output.address !== 'So11111111111111111111111111111111111111112') return
            let quoteResponse = await (
                await fetch('https://quote-api.jup.ag/v6/quote?inputMint=' +
                    this.input.address + '&outputMint=So11111111111111111111111111111111111111112&amount=' +
                    (this.inAmount*1e9) + '&slippageBps=50' //&platformFeeBps=50'
                )
            ).json();
            console.log('quote', quoteResponse)
            this.quoteResponse = quoteResponse
            return quoteResponse
        },
        async unstake() {
            // here we will simply use unstake.it.. who now recommend Jupiter, who have a simple api
            // Swapping SOL to USDC with input 0.1 SOL and 0.5% slippage
            let quoteResponse = await this.getSolQuote()
            console.log('fresh quoted', quoteResponse)
            // get serialized transactions for the swap
            const {swapTransaction} = await (
                await fetch('https://quote-api.jup.ag/v6/swap', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        // quoteResponse from /quote api
                        quoteResponse,
                        // user public key to be used for the swap
                        userPublicKey: this.wallet.publicKey.toString(),
                        // auto wrap and unwrap SOL. default is true
                        wrapAndUnwrapSol: true,
                        // feeAccount is optional. Use if you want to charge a fee.  feeBps must have been passed in /quote API.
                        // feeAccount: REFERRAL_ACCOUNT
                        prioritizationFeeLamports: 'auto',
                        autoMultiplier: 2,
                        dynamicComputeUnitLimit: true,
                    })
                })
            ).json();

            const swapTransactionBuf = Buffer.from(swapTransaction, 'base64');
            var transaction = VersionedTransaction.deserialize(swapTransactionBuf);
            console.log(transaction);
            console.log('swap', transaction)
            // const hash = await connection.getLatestBlockhash();
            // transaction.recentBlockhash = hash.blockhash;


            let [ txid, success ] = await this.sendTx(transaction)
        },
        swapDirection() {
            let temp = this.input
            this.input = this.output
            this.output = temp
            this.ratio = 1 / this.ratio
            this.getSolQuote()
        },
        async getBalances() {
            if (!this.wallet.connected) return
            let balances = await getAssetsByOwner(this.wallet.publicKey)
            this.balances = collect(balances).keyBy('id').filter((item) => item?.token_info).map((item) => {
                return (item.token_info.balance /1e9) || 0
            }).all()
            this.balances['So11111111111111111111111111111111111111112'] = (await getSolBalance(this.wallet.publicKey)) / 1e9
        },
        async sendTx(transaction) {
            var success
            const wallet = this.wallet
            try {
                console.log('sending tx',transaction)
                let txid
                txid = await wallet.sendTransaction(transaction, connection, {
                    skipPreflight: true,
                    maxRetries: 2
                })

                console.log('tx sent')
                const getConfirmation = async (connection, tx) => {
                    const result = await connection.getSignatureStatus(tx, {
                        searchTransactionHistory: true,
                    });
                    return result;
                };
                const result = await getConfirmation(connection, txid);
                console.log('tx processed', result)
                if (result) {
                    ElNotification({
                        title: 'Success',
                        message: 'Successfully staked SOL',
                        type: 'success',
                        duration: 5000,
                        customClass: 'text-left'
                    })

                    success = true
                } else {
                    ElNotification({
                        title: 'Error',
                        message: 'Transaction failed',
                        type: 'error',
                        customClass: 'text-left',
                        duration: 5000
                    })
                    success = false
                }
                this.getBalances()
                return [txid , success]
            } catch (e) {
                console.log(e)
                ElNotification({
                    title: 'Error',
                    message: "Transaction failed:\n" + e,
                    type: 'error',
                    customClass: 'text-left',
                    duration: 5000
                })
                success = false
                this.getBalances()
                return [ null, success]
            }


        },
        clicky: function (url) {
            if (typeof clicky === 'object') {
                // eslint-disable-next-line
                clicky.log(url)
                clicky.goal("Swapped to compassSOL",this.inAmount)
            }
        },



    },
    computed: {
        outAmountDisplay() {
            if (this.input.symbol == 'SOL') return (this.inAmount * this.ratio).toFixed(9)
            else return ((this.quoteResponse?.outAmount || 0)/ 1e9).toFixed(9)
        },

    },
    watch: {
        'wallet.connected': {
            immediate: true,
            handler(val) {
                if (val) this.getBalances()
                else this.balances = collect()
            }
        }
    }

})
</script>

<template>
                <div class="card bg-dark text-light w-100">
                    <div class="card-header lead font-weight-semibold">
                        <img src="https://solanacompass.com/compass.png" alt="compassSOL" class="brround bg-white" style="margin-right:10px; width: 32px; height: 32px; float: left">
                        compassSOL LST
                        <!-- swap direction -->
                        <button class="btn btn-secondary btn-xs lead ml-auto" style="float: right; margin-left:auto" @click="swapDirection"><i class="fas fa-exchange-alt bg-white" data-v-7b3c349e=""></i></button>

                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="amount" class="w-100">Swap
                                <img :src="input.icon" :alt="input.symbol" class="brround" style="margin-right:10px; width: 32px; height: 32px; float: left">
                                {{ input.symbol }}

                                <a style="float:right; margin-left:auto" class="text-muted small"
                                   href="#"
                                   @click="this.inAmount = balances[input.address]"

                                >
                                    {{ (balances[input.address] || 0 ).toFixed(6)  }} {{ input.symbol }}
                                </a>
                            </label>
<!--                            <token-selector v-model="input"></token-selector>-->
                            <input type="number" class="form-control text-right" id="amount" v-model="inAmount" @input="getSolQuote">
                        </div>
                        <div class="form-group">
                            <label for="amount" class="w-100">To
                                <img :src="output.icon" :alt="output.symbol" class="brround" style="margin-right:10px; width: 32px; height: 32px; float: left">
                                {{ output.symbol }}
                                <span style="float:right; margin-left:auto" class="text-muted small">
                                    {{ (balances[ output.address ] || 0 ).toFixed(6)  }} {{ output.symbol }}
                                </span>
                            </label>
<!--                            <token-selector v-model="output"></token-selector>-->
                            <input type="number" class="form-control text-right" id="amount" v-model="outAmountDisplay" disabled>
                        </div>
                        <div class="form-group">
                            <el-tooltip content="You are not allowed to stake from a restricted territory"
                                        placement="top"
                                        v-if="window.geo == 'GB'">
                                <button class="btn bg-gradient-info btn-lg w-100" disabled>Unsupported Region</button>
                            </el-tooltip>
                            <button class="btn bg-gradient-info btn-lg w-100" v-else
                                    :disabled="!wallet.connected"
                                    @click="swap"
                            >
                                <span class="lead" v-if="!wallet.connected">Connect Wallet</span>
                                <span class="lead" v-else>Stake</span>
                            </button>
                        </div>
                        <div class="form-group small text-muted row" v-if="input.symbol == 'SOL'">
                            <dt class="col">
                                Pool Ratio
                            </dt>
                            <dd class="col text-right">
                                1 {{input.symbol}} = {{ratio.toFixed(4)}} {{output.symbol}}
                            </dd>
                        </div>
                        <div class="form-group small text-muted row" v-else>
                            <dt class="col-6">
                                Jupiter Route
                            </dt>
                            <dd class="col-6 text-right" v-if="quoteResponse?.routePlan?.length>0">
                                <span v-for="route in quoteResponse.routePlan" :key="route.symbol">
                                    {{route.swapInfo?.label }} <i class="fas fa-arrow-right"></i>
                                </span>
                            </dd>

                            <dt class="col-6">
                                Max slippage
                            </dt>
                            <dd class="col-6 text-right" >
                                {{ (((quoteResponse?.slippageBps) || 0)/1000).toFixed(2) }}%
                            </dd>
                            <dt class="col-6">
                                Price Impact
                            </dt>
                            <dd class="col-6 text-right" >
                                {{ ((Number(quoteResponse?.priceImpactPct)*100) || 0).toFixed(2) }}%
                            </dd>

                        </div>
                    </div>

            </div>

</template>

<style scoped>

</style>
